import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as ReactGA from 'react-ga';
import { UserProfileContext } from 'auth/contexts/UserProfileContext';
import { FormattedMessage, injectIntl } from 'react-intl';
import Modal from '../../components/Modal';
import styles from './FeedbackButton.css';

class FeedbackButton extends Component {
  state = {
    showModal: false,
  };

  // shows the google forms dialog
  handleClick = () => {
    this.toggleModal();
  };

  handleCloseModal = () => {
    this.toggleModal();
  };

  toggleModal() {
    this.setState(
      prevState => {
        return {
          showModal: !prevState.showModal,
        };
      },
      () => {
        const { showModal } = this.state;
        try {
          ReactGA.event({
            category: 'Search-Feedback',
            action: showModal ? 'ShowDialog' : 'CloseDialog',
          });
        } catch (err) {
          // silently fail
        }
      },
    );
  }

  render() {
    const { showModal } = this.state;
    // const { browser, location } = this.props;
    const { profile } = this.context;
    // const browserInfo = `${browser.name}::${browser.version}`;
    // const pageInfo = `${location.pathname}${location.search}`;
    const userInfo = profile
      ? `${profile.firstName} ${profile.lastName} / ${profile.email}`
      : '';
    const formUrl = `${
      process.env.REACT_APP_FEEDBACK_FORM_URL
    }${encodeURIComponent(userInfo)}&embedded=true`;
    return (
      <React.Fragment>
        <div role="button" className={styles.FeedbackButtonWrapper}>
          <div className={styles.FeedbackButton} onClick={this.handleClick}>
            {/* <FeedbackIcon /> */}
            <span>
              <FormattedMessage id="feedback.link" />
            </span>
          </div>
        </div>
        <Modal
          className={styles.FeedbackModal}
          onClose={this.handleCloseModal}
          showModal={showModal}
        >
          <iframe
            title="Feedback Form"
            src={formUrl}
            width="800"
            height="1000"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
          >
            Loading…
          </iframe>
        </Modal>
      </React.Fragment>
    );
  }
}
FeedbackButton.contextType = UserProfileContext;
const mapStateToProps = ({ app }) => ({
  browser: app.browser,
});
export default withRouter(connect(mapStateToProps)(injectIntl(FeedbackButton)));



// WEBPACK FOOTER //
// ./src/views/containers/Search/FeedbackButton.jsx